import {Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererComp,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
import {debounceTime, distinctUntilChanged, map, Observable} from "rxjs";
// import { CellCustomComponent } from './cell-custom/cell-custom.component';
import {FormBuilder, FormControl, FormGroup, PatternValidator, Validators} from '@angular/forms';
import {BtnCellRenderer} from 'src/app/common/button-cell-renderer.component';
import {ModalComponent} from 'src/app/common/modal/modal.component';
import {ModalConfig} from 'src/app/common/modal/modal.config';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmPasswordValidator} from "../merchants.validator";
import {environment} from "../../../../../../environments/environment";
import {ApiHttpService} from "../../../../../_services/api-http.service";
import {DatePipe, Location} from "@angular/common";
import {MenusService} from "../../../../../_services/menu.service";
import {AlertService} from "../../../../../_services/alert.service";
import {MerchantService} from "../merchant.service";

const {API_URL,defaultCurrency} = environment;

export interface IMerchantData {
  "id": number,
  "merchantId": string,
  // "productId": string,
  "accountNumber": string,
  "ifscCode": string,
  "bankName": string,
  "rodate": string,
  "emailId": string,
  "mobileNo": string,
  "account_holder": string
}


export class DetailCellRenderer implements ICellRendererComp {
  eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = '<h1 style="padding: 20px;">My Custom Detail</h1>';
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}

@Component({
  selector: 'app-merchant-account-list',
  templateUrl: './merchant-account-list.component.html',
  styleUrls: ['./merchant-account-list.component.scss']
})
export class MerchantAccountListComponent implements OnInit {

  @Input() merchantId: string;
  @Input() onMerchantChange: EventEmitter<any> = new EventEmitter<any>();
  selectedmerchant: number;
  accountform: FormGroup;
  isForm1Submitted: Boolean;
  currentURL: Boolean = false
  public detailCellRenderer = new DetailCellRenderer;
  modalConfigDelete: ModalConfig;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true
  };
  loading: boolean = false
  public rowData!: IMerchantData[];
  tablecolumn: any;
  currentPage: number = 1;
  pageSize: number = 10;
  globalSearch: string = '';
  collectionSize: number = 0;
  SingleRow: any;
  tableInfo: any;
  Resdata: any;
  Resdatas: any;
  isDisable: boolean = false;
  isverify: string = 'N';
  isValid: string = 'N';
  isChecked: boolean = true;
  newDate: any = new Date()
  verifyButton: any = true
  loader = false
  selectedAttributes: any
  arr: any = {}
  public IFSCValue: string = '';
  public currency : string = defaultCurrency;
  randomdata: { merchantid: string; };
  public nameRegex = /^[A-Za-z ]+$/
  public numberRegex = [0-9]
  public alphaNumberic = "^[a-zA-Z0-9_]*$";
  public ibanRegex = /^AE\d{2}\d{3}\d{16}$/;
  editableCheck : boolean = true;
  editEnable : boolean = true;
  isIbanValidated: boolean = false;
  private initialAccountFormValue: any = null;

  public columnDefs: ColDef[] = [
    // {field: 'id', tooltipField: 'id', headerName: 'ID',},
    //  {field: 'productId', tooltipField: 'productId', headerName: 'Product ID'},
    {field: 'bankName', tooltipField: 'bankName', headerName: 'Bank Name',lockVisible:true,},
    {field: 'accountTitle', tooltipField: 'isVerified', headerName: 'Account Title',lockVisible:true,},
    {field: 'iban', tooltipField: 'bankName', headerName: 'RIB',lockVisible:true,},
    {field: 'currency', tooltipField: 'isVerified', headerName: 'Currency',lockVisible:true,},
    {
      field: 'action', headerName: 'Action',autoHeight:true,lockVisible:true, resizable: true, cellRenderer: BtnCellRenderer, cellRendererParams: [
        {
          clicked: async (field: any, param: any) => {
          this.deleteAccount(param.data.id,this.merchantId);
          },
          buttonIconClass: 'icon-trash'
        },
     
      ]
    },
  ];
  public tableSelectedColumn: ColDef[] = [...this.columnDefs];
  public permissions: any;
  Requestbody: any;
  Ress: any;
  errorMessage: any;
  formData: any;
  IFSCvalue: any;
  validIFSC: any;
  validationIFSC: boolean;
  IFSCcheck: boolean;
  ValidAccount: boolean = true;
  errorOccured: boolean = false;
  IFSCData: any;
  param: IMerchantData;
  highlight: boolean;
  IFSCBank: any;
  BankValue: any;
  AccountUserName: any = '';
  @ViewChild('modalDelete') private modalDeleteComponent: ModalComponent
  private gridApi!: GridApi;
  private filterObj: any = {};
  private merchantValue: null;
  private merchantresponse: any;
  private queryParams: any = {};

  constructor(private alertService: AlertService, private datePipe: DatePipe,
    private merchantService: MerchantService, private menuService: MenusService, private location: Location, private route: ActivatedRoute, private router: Router, private apiHttpService: ApiHttpService, fb: FormBuilder) {
    var URL = this.router.url

    if (URL.indexOf("merchant-master") > 0) {
      this.currentURL = true
    } else {
      this.currentURL = false

    }

    this.MerchnatList()
    // this.accountform = fb.group({
    //   id:[null,""],
    //     merchantId: [this.merchantId || "", Validators.required],
    //     productId: [""],
    //     nostroAccount: ["", [Validators.required, Validators.maxLength, Validators.minLength]],
    //     bankName: ["", [Validators.required,]],
    //     accountNumber: ["", [Validators.required, Validators.maxLength, Validators.minLength]],
    //     accountTitle: ["", [Validators.required, Validators.maxLength, Validators.minLength]],
    //     intermediaryBankSwift: ["", [Validators.required,]],
    //     intermediaryBank: ["", [Validators.required,]],
    //     bankAddress: ["", [Validators.required,]],
    //     swiftCode: ["", [Validators.required,]],
    //     iBan: ["", [Validators.required, Validators.maxLength, Validators.minLength]],
    //     curreny: ["", [Validators.required,]],
    //     // productId: ["",Validators.pattern("[!@#$%^&*()_+\-=\[\]{};':]")],
    //     //productId: ["",Validators.pattern("^[a-z0-9]{8,15}$")],
    //     rodate: [""],

    //   });

      this.accountform = fb.group({
        id:[null,""],
          merchantId: [this.merchantId || "", Validators.required],
          // productId: ["",Validators.required],
          bankName: ["", []],
          accountTitle: ["", []],
          // iBan: ["", [Validators.required, Validators.pattern(this.ibanRegex)]],
          iBan: ["", []],
          curreny: ["", [Validators.required,]],
        });

      this.accountform.get('curreny')?.setValue(this.currency);
    this.modalConfigDelete = {
      modalTitle: "Delete Confirmation",
      modalSize: 'sm',
      hideCloseButton(): boolean {
        return true
      },
      hideDismissButton(): boolean {
        return true
      }
    }
  }
  onFilterTextBoxChanged() {
    debugger
    
    this.gridApi.setQuickFilter(
      (document.getElementById('filter-text-box') as HTMLInputElement).value
    );
   
  }

  get form1() {
    return this.accountform.controls;
  }

  //requestBodydata={}
  validateAccount(formvalue:any){
debugger
    let requestBodydata={

      "accountNo": formvalue.accountNumber,
      "ifscCode": formvalue.ifscCode,
      "bankName": formvalue.bankName,
      "name": formvalue.account_holder,
     
       
        
     }


    this.merchantService.validate(requestBodydata).subscribe((data)=>{
      let ValidAccount=data;
      console.log("ValidAccount======="+JSON.stringify(ValidAccount))
      alert(JSON.stringify(data.text))
      if(data.text==="Verification Successful."){
          this.isverify="Y";
      }
    })
    this.ValidAccount==true;
    this.loading = false // required to be true when API will be intergated
  //  console.log(!(this.permissions.includes('Add') || this.permissions.includes('Edit')) ||  this.ValidAccount==true||this.loading)
    //console.log(this.permissions);
    
   // alert('Account Validation API needed.. Go ahead now');
  }
 
  editButton(){
    console.log("editButton")
    this.editableCheck = false;
    this.editEnable = false;
  }

  cancelButton(){
    this.editableCheck = true;
    this.editEnable = true;

    //Call api to set data again
    this.merchantService.getAccountDetails(this.merchantId).subscribe((response:any)=>{
      console.log(response.response.data)
      if(response.response.data != null){
        this.accountform.get('bankName')?.setValue(response.response.data.bankName);
        this.accountform.get('accountTitle')?.setValue(response.response.data.accountTitle);
        this.accountform.get('iBan')?.setValue(response.response.data.iban);
      }
    })
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.accountform.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }
id:any;
  editData(param: any) {

    return;
    if (param.isVerified == 'Y') {
      this.alertService.errorAlert({html: "Editing verified Account is not allowed!"})
      return
    }
    // this.rowData.forEach(element => {
    //   if(element.id == param.id){
    //     this.param = element
    //   }

    // });
    const regexPattern = /^[a-zA-Z0-9!@#$%^&*()+=\[\]{}|\\:;"'<>,.?\/`~]*$/;
    // if (this.param.productId.match(regexPattern)) {
      
    //   console.log('Valid string');
    //   return true;
    // } else {
    //   console.log('Invalid string');
    //   return false;
    // }
    this.param = param
    //alert(this.param.productId);

    this.accountform.patchValue({
      // formvalue.merchantId //formvalue.rodate
      "id":this.id || param.id,
      "merchantId": this.merchantId || param.merchantId,
      // "productId": this.param.productId || 'DEFAULT',
      "accountNumber": this.param.accountNumber,
      "retypeaccountNumber": this.param.accountNumber,
      "ifscCode": this.param.ifscCode,
      "bankName": this.param.bankName,
      "account_holder": this.param.account_holder,
      "mobile_number": this.param.mobileNo,
      "email_address": this.param.emailId
      ,
      "isVerified": this.isverify,
      "rodate": this.datePipe.transform(this.newDate.toString(), "yyyy-MM-dd")
    })
  }

  ngOnInit(): void {
    this.loading = false
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);

    if (this.merchantId) {
      this.isDisable = !this.isDisable;
    }
    this.route.queryParams
      .subscribe(params => {
          this.queryParams = params;
          this.merchantId = params?.mid || null;
          this.isDisable = true;
          this.accountform.get('merchantId')?.setValue(this.merchantId);
          this.accountform.get('merchantId')?.disable();
          this.onMerchantChange.emit(this.merchantId);
          this.merchantService.getAccountDetails(this.merchantId).subscribe((response:any)=>{
            console.log(response.response.data)
            if(response.response.data != null){
              this.accountform.get('bankName')?.setValue(response.response.data[0].bankName);
              this.accountform.get('accountTitle')?.setValue(response.response.data[0].accountTitle);
              this.accountform.get('iBan')?.setValue(response.response.data[0].iban);
              // Store initial form value for change detection
              this.initialAccountFormValue = {
                bankName: response.response.data[0].bankName,
                accountTitle: response.response.data[0].accountTitle,
                iBan: response.response.data[0].iban,
                curreny: this.accountform.get('curreny')?.value
              };
            }
          })
        }
      );

    this.isForm1Submitted = false;
    // @ts-ignore
    this.onMerchantChange.subscribe((data) => {
      this.merchantId = data;
      <FormControl><unknown>this.accountform.get('merchantId')?.patchValue(data);
      this.refreshGrid(this.merchantId);
    })

    this.accountform.get('iBan')?.valueChanges.subscribe(() => {
      this.isIbanValidated = false;
    });

    // this.BanKName();

    if (!(this.permissions.includes('Add'))) {
      this.accountform.disable()
    }
  }

  // DeleteAccount(ID: any) {
  //   let data = {
  //     "Pid": ID.id || ID
  //   }

  //   return this.apiHttpService
  //     .post(
  //       `${API_URL}/delete-merchantbank-byid`, data
  //     );

  // }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.rowData.filter(v => (v.merchantId.toLowerCase().indexOf(term.toLowerCase()) > -1)).map(v => v.merchantId).slice(0, 10))
    );

  async closeModelAction($event: Event) {
    await this.modalDeleteComponent.dismiss();
    this.refreshGrid(this.merchantId);
  }

  deleteAccount(id:any,userId:any){
    console.log(id,userId)
    this.merchantService.deleteAccountDetails(id,userId).subscribe((response)=>{
      if(response.response.status == 200){
        this.alertService.successAlert(response.response.message,"");
        this.merchantService.getAccountDetails(userId).subscribe((data)=>{
          this.rowData = data.response.data;
          this.collectionSize = data.response.data.length
          this.accountform.get('bankName')?.setValue("");
          this.accountform.get('accountTitle')?.setValue("");
          this.accountform.get('iBan')?.setValue("");
        })
      }else{
        this.alertService.errorAlertWithMessage("Error while deleting the account details")
        this.accountform.get('bankName')?.setValue("");
        this.accountform.get('accountTitle')?.setValue("");
        this.accountform.get('iBan')?.setValue("");
      } 
    })
  }
  refreshGrid(Mid: any) {

    if (this.accountform.controls['merchantId'].value === "") {
      this.merchantValue = null
    } else {
      this.merchantValue = this.accountform.controls['merchantId'].value
    }
    let data = {
      "merchantid": this.merchantId || this.merchantValue || Mid || ""
    }
    this.gridApi.showLoadingOverlay();

    return this.apiHttpService
      .post(
        `${API_URL}/get-merchantbank`, data
      )
      .subscribe((data: any) => (this.rowData = data?.data || data, this.collectionSize = data?.totalCount || data?.length));
  }

  updateSelectedTimeslots(event: any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefs[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefs[parseInt(event.target.value)]);

      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefs[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefs[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }


  loadDatabyMid() {

    //this.accountform.controls['merchantId'].setValue(mid)
    this.refreshGrid(this.merchantId);
  }

  onGridReady(params: GridReadyEvent<any>) {

    // let data = {
    //   "merchantid": this.merchantId || this.accountform.controls['merchantId'].value == "" ? null : this.accountform.controls['merchantId'].value
    // }
    if (this.accountform.controls['merchantId'].value === "") {
      this.merchantValue = null
    } else {
      this.merchantValue = this.accountform.controls['merchantId'].value
    }
    let data = {
      "merchantid": this.merchantId || this.merchantValue
    }
    this.gridApi = params.api;
    this.gridApi.setColumnDefs(this.columnDefs);
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();

    // return this.merchantService.getAccountDetails(this.merchantId).subscribe((data: any) => (
    //   this.rowData = data.response.data || data, 
    //   this.collectionSize = data.response.data.length || data?.length));

  }

  onBtnC(e: Event) {
    e.preventDefault();
    // @ts-ignore
    var data = {
      "merchantid": this.merchantId || this.accountform.controls['merchantId'].value == "" ? null : this.accountform.controls['merchantId'].value
    }
    return this.apiHttpService
      .post(
        `${API_URL}/get-merchantbank`, data
      )
      // @ts-ignore
      .subscribe((data) => (this.gridApi.applyTransaction({add: data})));
  }

  onExportCSV() {
    // @ts-ignore
    this.gridApi.exportDataAsCsv()
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.gridApi.paginationGoToPage(param - 1)
    // let postdata = {
    //   "merchantid": "M0002"
    // }
    // // this.gridApi.paginationSetPageSize()
    // console.log("onPaginationChange----->", param, this.pageSize);
    // this.gridApi.applyTransaction({remove: this.rowData})
    // this.gridApi.showLoadingOverlay();
    //
    // this.apiHttpService
    //   .post(
    //     `${API_URL}/get-merchantbank?pageSize=` + this.pageSize + '&page=' + (param - 1), postdata
    //   )
    //   .subscribe((data) => (console.log("****onGridReady"), this.rowData = data?.data || data, this.collectionSize = data?.totalCount || data?.length));
  }

  async onRowClicked(param: RowClickedEvent | any) {
    debugger
    this.SingleRow = param.data
    let dvalue=param.data
    
    this.id=dvalue.id
   
     this.accountform.get('id')?.setValue(dvalue.id);
    this.accountform.get('merchantId')?.setValue(dvalue.merchantId);
    // this.accountform.get('productId')?.setValue(dvalue.productId);
    this.accountform.get('accountNumber')?.setValue(dvalue.accountNumber);
    this.accountform.get('account_holder')?.setValue(dvalue.account_holder);
    this.accountform.get('ifscCode')?.setValue(dvalue.ifscCode);
    this.accountform.get('bankName')?.setValue(dvalue.bankName);

    this.accountform.get('mobile_number')?.setValue(dvalue.mobileNo);
    
    this.accountform.get('email_address')?.setValue(dvalue.emailId);
     this.accountform.get('retypeaccountNumber')?.setValue(dvalue.accountNumber);
    // this.accountform.get('isVerified')?.setValue(dvalue.isVerified);
    // this.accountform.get('status')?.setValue(dvalue.status);
    // this.accountform.get('id')?.setValue(dvalue.id);
   // this.accountform.controls.['merchantId'].patchValue(dvalue.merchantId);
   // alert(JSON.stringify(this.SingleRow.mobileNo))
    //console.log("JSON.stringify(this.SingleRow)==========="+JSON.stringify(this.SingleRow.mobileNo));
    // await this.modalDeleteComponent.openData(this.SingleRow)

  }

  onRowDoubleClicked(param: RowClickedEvent | any) {
    param.node.setExpanded(!param.node.expanded);
  }

  onFilterChange(param: FilterChangedEvent | any) {
    debugger
    let Requestbody = {
      "merchantid": this.merchantId || this.accountform.controls['merchantId'].value == "" ? null : this.accountform.controls['merchantId'].value
    }
    // this.rowData.length = 0
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();

    const self = this;
   
    self.apiHttpService
      .post(
        `${API_URL}/get-merchantbank?pageSize=${this.pageSize}&page=${(this.currentPage - 1)}`, Requestbody
      )
  
      .subscribe((data) => (self.gridApi.applyTransaction({
        add: data?.filter((dt: any) => {
          if (dt.age == self.filterObj?.age?.appliedModel.filter)
            return dt;
        })
      }))); 
    // }, 1000)

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onPageSizeChanges($event: Event) {
    
    let Requestbody = {
      "merchantid": this.merchantId || this.merchantValue
      //"merchantid": this.merchantId || this.accountform.controls['merchantId'].value == "" ? null : this.accountform.controls['merchantId'].value
    }

    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const urlToFetch = `${API_URL}/get-merchantbank?pageSize=${this.pageSize}&page=${(this.currentPage - 1)}`;
    // setTimeout(()=>{
      
      
      this.apiHttpService
      .post(urlToFetch, Requestbody)
      .subscribe((data: any) => {
       // alert(JSON.stringify(data));
      (this.rowData = data?.data || data, this.collectionSize = data?.totalCount || data?.length)
  });

 /*   this.apiHttpService
      .post(
        `${API_URL}/get-merchantbank?pageSize=` + this.pageSize + '&page=' + (this.currentPage - 1), Requestbody
      )
      .subscribe((data: any) => (
        this.rowData = data?.data, this.collectionSize = data?.totalCount, this.gridApi.applyTransaction({add: this.rowData})
        ));*/

  }
  accountNumberdis: boolean = true;
  accountNumberError: string = '';

  validateIban(){
    this.isForm1Submitted = true;
    this.isIbanValidated = false;


    if (this.accountform.valid) {
      this.merchantService.validateIban(this.accountform?.get('iBan')?.value).subscribe({
        next: (response: any) => {
          if(response.response.status == 200){
            const data = response.response.data;
            this.alertService.successAlert(response.response.message)
            if (data != null) {
              this.accountform.get('bankName')?.setValue(data.bankName);
              this.accountform.get('accountTitle')?.setValue(data.accountName);
              this.accountform.get('iBan')?.setValue(data.iban);
              this.isIbanValidated = true;
            }
          }else{
            this.alertService.errorAlertWithMessage(response.response.message)
          }
          
        },
        error: (error: any) => {
          this.alertService.errorAlertWithMessage(error.response?.message || 'An error occurred');
        }
      });
    }
  }
  
  onSubmit(formvalue: any, type: any) {
    this.isForm1Submitted = true;
    // Compare current form value with initial value
    const current = {
      bankName: this.accountform.get('bankName')?.value,
      accountTitle: this.accountform.get('accountTitle')?.value,
      iBan: this.accountform.get('iBan')?.value,
      curreny: this.accountform.get('curreny')?.value
    };
    if (this.initialAccountFormValue && JSON.stringify(current) === JSON.stringify(this.initialAccountFormValue)) {
      this.alertService.errorAlertWithMessage("No change in Account Details");
      return;
    }
    console.log(this.merchantId)
    console.log(formvalue);
    console.log(type)
    setTimeout(() => {
      if (type === "grid") {
        // Your existing code for grid submission...
      } else {
        if (this.accountform.valid) {
          console.log(formvalue);
          
          // let accountUrl = `${API_URL}/isDetailExitsInShield`;
          // const requestAccountData = { type: "accountNumber", data: this.accountform.value.accountNumber };
          // this.apiHttpService.post(accountUrl, requestAccountData).subscribe(accountData => {
          //   // Assuming accountData contains information about accountNumber existence
          //   this.accountNumberdis = !(accountData.statusCode === "0000" && accountData.data === true);
          //   if (!this.accountNumberdis) {
          //     this.accountNumberError = 'This Account Number already exists!';
          //     setTimeout(() => {
          //       this.accountNumberError = '';
          //     }, 3000);
          //   } else {
          //     // Proceed with form submission if account number is valid
          //     // Your form submission logic...
          //   }
          // });

          let request = {
            "userId":this.merchantId,
            // "productId":formvalue.productId,
            "bankName":formvalue.bankName,
            "accountTitle":formvalue.accountTitle,
            "iban":formvalue.iBan,
            "currency":this.currency,
          }
          console.log(request);
          this.merchantService.saveAccountDetails(request).subscribe((response)=>{
            console.log(response);
            if(response.response.status == 200 && (response.response.message == "Account details saved successfully" || response.response.message =="Account details updated successfully")){
              this.alertService.successAlert(response.response.message)
               //Call api to set data again
              this.merchantService.getAccountDetails(this.merchantId).subscribe((response:any)=>{
                console.log(response.response.data)
                if(response.response.data != null){
                  this.accountform.get('bankName')?.setValue(response.response.data.bankName);
                  this.accountform.get('accountTitle')?.setValue(response.response.data.accountTitle);
                  this.accountform.get('iBan')?.setValue(response.response.data.iban);
                  this.initialAccountFormValue = {
                    bankName: response.response.data.bankName,
                    accountTitle: response.response.data.accountTitle,
                    iBan: response.response.data.iban,
                    curreny: this.accountform.get('curreny')?.value
                  };
                }
              })
              this.editableCheck = true;
              this.editEnable = true;
            }else if(response.response.status == 200){
              this.alertService.errorAlertWithMessage(response.response.message)
            }
            else{
              this.alertService.errorAlertWithMessage(response.response.message)
            }
          })
          this.isForm1Submitted = false;
        }
  
        
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.highlight = false;
        document?.getElementById(this.findInvalidControls()[0])?.focus();
  
        setTimeout(() => {
          this.highlight = true;
        }, 1000);
      }
    }, 0);
  }
  
  downloadReport(Merchantdata :any) {
    // debugger
    // this.apiHttpService
    // .post(
    //   `${API_URL}/docs/download/${Merchantdata}/MCR`, null
    //   )
    // .subscribe((data) => (
    //  this.downloadPdf(data)
    // ));

    this.downloadPdf(Merchantdata)
  }
  downloadPdf(data:any) {
    const linkSource =
    'data:application/octet-stream;base64,' +data;
    const downloadLink = document.createElement('a');
    const fileName = 'MerchantBankDetails.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }





  reset() {
    this.accountform.reset(); // Reset form data
  }

  //get merchant By Name
  MerchnatList() {


    var merchantdata = {
      "name": ""
    }
    this.apiHttpService
      .post(
        `${API_URL}/GetMerchant`, merchantdata
      )
      .subscribe((res: any) =>
        (this.Resdata = res));


  }

  //call api serviceProvide dropdown
  BanKName() {

    let bankdata = {
      "Type": "13",
      "Value": ""
    }
    this.apiHttpService
      .post(
        `${API_URL}/GetDropdown`, bankdata
      )
      .subscribe((res) =>
        (console.log("****onGridReady" + res),
            this.Resdatas = res,
            res.forEach((element: any, i: any) => {
              this.arr["id"] = element.FieldText
              this.arr["name"] = element.FieldValue
              console.log(this.arr);

            })
        ))


  }



  keyPressAlphaNumeric(event:any) {
    //const regexPattern = /^[a-zA-Z0-9!@#$%^&*()+=\[\]{}|\\:;"'<>,.?\/`~]*$/;
    const regexPattern = /^[a-zA-Z0-9-_]*$/;
    
  
    var inp = String.fromCharCode(event.keyCode);

    // if (/[a-zA-Z0-9]/.test(inp)) {
      if (regexPattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  // end call api serviceProvide dropdown

  previousStep($event: MouseEvent) {
    this.router.navigate(['/merchants/merchant-creation/merchant-add'], {
      queryParams: {...this.queryParams}
    })
  }

  nextStep($event: MouseEvent) {
    this.router.navigate(['/merchants/merchant-creation/merchant-kyc'], {
      queryParams: {...this.queryParams}
    })
  }

  OnlyNumbersAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode > 47 && charCode < 58) || charCode == 46;

  }

  OnlyNumbersAllowedWithoutDecimal(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode > 47 && charCode < 58);

  }

  OnlySpecialAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode >= 41 && charCode <= 57) && (charCode == 100) && (charCode >= 133 && charCode <= 140) && (charCode >= 173 && charCode <= 176);

  }

  OnlyCharacterNumberAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || (charCode == 32)) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || (charCode == 32)) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey")
  }

  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey")
  }


  upperCase($event: Event): void {
    // this.IFSCValue = this.IFSCValue.toUpperCase();
  }


}


var filterParams = {
  // @ts-ignore
  comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('/');
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0])
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
  },
  browserDatePicker: true,
};
